/**
 * Created by lari on 08/06/2017.
 */
(function () {
  'use strict';
  angular.module('vcfinance.unicat')
    .component('unicatform', {
      restrict: 'E',
      bindings: {
        unicat: '<',
        parentsave: '&',
        oncancel: '&'
      },
      templateUrl: 'vcfinance/unicat/unicatform-component.tpl.html',
      controllerAs: 'vm',
      controller: ['$log',
        function ($log) {
          let vm = this;
          vm.save = save;
          vm.cancel = cancel;
          // vm.zipsave = zipsave;
          
          vm.$onInit = function () {
            vm.lastunicat = angular.copy(vm.unicat);
          };
          
          function save() {
            if (!angular.equals(vm.unicat, vm.lastunicat)) {
              vm.lastunicat = angular.copy(vm.unicat);
              vm.parentsave({unicat: vm.unicat});
            }
          }
          
          function cancel() {
            vm.unicat = angular.copy(vm.lastunicat);
            vm.oncancel();
          }
          
/*          function zipsave (zip, city) {
            $log.debug('debug: unicatform zipsave called: ', zip, city);
            // vm.unicat.postcode = zip;
            // vm.unicat.city = city;
          }*/
          
          
          
        }] // controller
    }); // component

// klammerfriedhof
}());